<template>
  <div>
    <div
      :class="[i === user.casualGroups.length - 1 && 'last']"
      class="d-flex py-1 table-row-wrapper"
      v-for="(item, i) in user.casualGroups"
      @click="() => $emit('groupClicked', item)"
    >
      <div class="name-cell px-2 fs-1-12r">
        {{ item.name }}
      </div>
      <div class="details-cell px-2">
        <div v-if="parent === 'admin' && user.license === 'SFTP'">
          <Button
            text="Details"
            btnType="blue"
            class="mx-2"
            :clickAction="() => sftpDetailsUploadingClicked(item)"
          />
        </div>
      </div>
      <div class="actions-cell px-2">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              @click="() => $emit('groupClicked', item)"
              v-on="on"
              x-small
              rounded
              outlined
              fab
              color="grey"
              class="mr-2"
            >
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Edit group</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              @click.stop="deleteGroupClicked(i)"
              v-on="on"
              x-small
              rounded
              outlined
              fab
              color="error"
            >
              <v-icon dark>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Delete group</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import { confirmDialog } from '@/utils'
import { api } from '@/config/'
import { mapMutations } from 'vuex'
export default {
  name: 'TableHeader',
  props: { user: Object, parent: String },
  components: {
    Button,
  },
  emits: ['sftpDetailsUploadingClicked', 'groupClicked'],
  methods: {
    ...mapMutations(['SET_PROCESSING']),
    sftpDetailsUploadingClicked(item) {
      this.$emit('sftpDetailsUploadingClicked', item)
    },
    async deleteGroupClicked(i) {
      try {
        this.SET_PROCESSING(true)
        confirmDialog(
          this,
          this.$t('Are you sure you want to delete this group?'),
          this.$t('Delete Group'),
          this.$t('Cancel'),
          async () => {
            try {
              this.user.casualGroups.splice(i, 1)
              const res = await api.put(
                `casuals/${this.user.userId}/update-casuals`,
                {
                  casuals: this.user.casualUsers,
                  groups: this.user.casualGroups,
                }
              )
              if (res.status !== 200) throw new Error('Error updating casuals')
              this.user.casualUsers = res.data.casuals
              this.user.casualGroups = res.data.groups
            } catch (error) {
              console.log(error)
            }
          }
        )
      } catch (e) {
        console.log(e)
      } finally {
        this.SET_PROCESSING(false)
      }
    },
  },
  computed: {},
}
</script>

<style scoped>
.table-row-wrapper {
  border-right: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  align-items: center;
  cursor: pointer;
}
.name-cell {
  flex-grow: 1;
}
.details-cell {
  min-width: 200px;
  max-width: 200px;
  width: 200px;
  display: flex;
  justify-content: center;
}
.actions-cell {
  display: flex;
  justify-content: center;
  min-width: 90px;
  max-width: 90px;
  width: 90px;
}
.last {
  border-radius: 0 0 10px 10px;
}
</style>
